import { i18n } from "@/plugins/i18n";
import moment from "moment";

// All date helpers are getter functions, not module-level constants.
// Module-level constants are evaluated once at import time. If the app stays open
// past midnight the values become stale and "Today"/"Yesterday" presets silently
// point to the wrong day. Getter functions always return the current date at
// call time, so presets stay accurate regardless of how long the tab is open.
export const getCurrentDate = () => moment().format("YYYY-MM-DD");
export const getYesterday = () => moment().subtract(1, "days").format("YYYY-MM-DD");
export const getFirstDayThisMonth = () => moment().startOf("month").format("YYYY-MM-DD");
export const getFirstDayThisYear = () => moment().startOf("year").format("YYYY-MM-DD");
export const getLastDayThisMonth = () => moment().endOf("month").format("YYYY-MM-DD");
export const getNinetyDaysAgo = () => moment().subtract(90, "days").format("YYYY-MM-DD");
export const getNDaysAgo = (amount: number) =>
  moment().subtract(amount, "days").format("YYYY-MM-DD");
export const getNMonthsAgo = (amount: number) =>
  moment().subtract(amount, "months").format("YYYY-MM-DD");

export interface PresetDate {
  label: string;
  value: Date[] | string[] | Date | string;
}

export const getDateRangePresets = (): PresetDate[] => [
  {
    label: i18n.global.t("dateRangePicker.today"),
    value: [getCurrentDate(), getCurrentDate()],
  },
  {
    label: i18n.global.t("dateRangePicker.yesterday"),
    value: [getYesterday(), getYesterday()],
  },
  {
    label: i18n.global.t("dateRangePicker.lastThreeDays"),
    value: [getNDaysAgo(2), getCurrentDate()],
  },
  {
    label: i18n.global.t("dateRangePicker.lastSevenDays"),
    value: [getNDaysAgo(6), getCurrentDate()],
  },
  {
    label: i18n.global.t("dateRangePicker.lastThirtyDays"),
    value: [getNDaysAgo(29), getCurrentDate()],
  },
  {
    label: i18n.global.t("dateRangePicker.thisMonth"),
    value: [getFirstDayThisMonth(), getLastDayThisMonth()],
  },
];
